import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import Api from './api'
import router from './router'
import store from './store'
import './bootstrap-vue'
import './scss/app.scss'
import './plugins/axios'
import IdleVue from 'idle-vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from './ability/index'
import Vuelidate from 'vuelidate'
import TreeView from 'vue-json-tree-view'
import './mixins/main'
import './mixins/pwa'
import './filters'

window.api = new Api()
window.moment = require('moment')

if (process.env.NODE_ENV === 'production') {
  const eventBus = new Vue()
  Vue.use(IdleVue, {
    eventEmitter: eventBus,
    store,
    idleTime: 100000,
    startAtIdle: false
  })
  // eslint-disable-next-line no-undef
  Vue.config.productionTip = false
  // eslint-disable-next-line no-undef
  Vue.config.devtools = false
  // eslint-disable-next-line no-undef
  Vue.config.debug = false
  // eslint-disable-next-line no-undef
  Vue.config.silent = true
} else {
  const eventBus = new Vue()
  Vue.use(IdleVue, {
    eventEmitter: eventBus,
    store,
    idleTime: 6000000,
    startAtIdle: false
  })
}
Vue.use(abilitiesPlugin, ability)
Vue.use(Vuelidate)
Vue.use(TreeView)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    console.log('APP CREATED')
    window.addEventListener('beforeunload', this.unloadHandler)
  },
  methods: {
    async unloadHandler() {
      console.log('Unloading App')
      // await this.$store.dispatch('branchUsers/commitNewVisitorsToCache')
    }
  },
  async beforeCreate () {
    await this.$store.dispatch('authentication/initialiseStore')
    await this.$store.dispatch('initialiseStore')
    await this.$store.dispatch('forms/initialiseStore')
  }
}).$mount('#app')
